import { __assign } from "tslib";
// P08
import React, { useContext, useReducer } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PopperManager, Popper } from '../../../Popover';
import DeviationFlagBase from './DeviationFlagBase';
import DailyDeviationFlag from './DailyDeviationCard';
import { MobileContext } from '../../../Context';
import s from './DeviationFlags.scss';
var createFlagStateReducer = function (isMobile) { return function (state, action) {
    switch (action) {
        case 'mouseEnter':
            return isMobile
                ? state
                : {
                    isFlagListVisible: true,
                    isHovering: true,
                };
        case 'mouseLeave':
            return isMobile
                ? state
                : __assign(__assign({}, state), { isHovering: false });
        case 'click':
            return isMobile
                ? state.isFlagListVisible
                    ? __assign(__assign({}, state), { isHovering: false }) : {
                    isFlagListVisible: true,
                    isHovering: true,
                }
                : state;
        case 'transitionEnd':
            return state.isHovering
                ? state
                : __assign(__assign({}, state), { isFlagListVisible: false });
        default:
            return state;
    }
}; };
var DeviationFlags = function (_a) {
    var dailyDeviation = _a.deviation.dailyDeviation, alwaysExpanded = _a.alwaysExpanded, disableLabel = _a.disableLabel, className = _a.className;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _b = useReducer(createFlagStateReducer(isMobile), {
        isFlagListVisible: false,
        isHovering: false,
    }), _c = _b[0], isFlagListVisible = _c.isFlagListVisible, isHovering = _c.isHovering, dispatch = _b[1];
    if (!dailyDeviation) {
        return null;
    }
    return (React.createElement("div", { className: classnames(s['root'], alwaysExpanded && s['always-expanded'], isHovering && s['hovering'], isFlagListVisible && s['visible'], disableLabel && s['disable-label'], className), onClick: function () { return dispatch('click'); }, onMouseEnter: function () { return dispatch('mouseEnter'); }, onMouseLeave: function () { return dispatch('mouseLeave'); }, onTransitionEnd: function (e) {
            if (e.propertyName === 'opacity') {
                dispatch('transitionEnd');
            }
        } },
        React.createElement(PopperManager, { renderReference: function (_a) {
                var ref = _a.ref;
                return (React.createElement(DeviationFlagBase, { innerRef: ref, title: t("actionbar.flags.dailyDeviation") }));
            } },
            React.createElement(Popper, { className: s['tooltip'], placement: isMobile ? 'top-end' : 'top-start', eventsEnabled: isFlagListVisible, positionOnly: true, renderInnerContent: function (_a) {
                    var placement = _a.placement;
                    return (React.createElement("div", { className: classnames(s['flag-list'], s[placement], isFlagListVisible && s['flag-list-visible']) },
                        React.createElement(DailyDeviationFlag, { dailyDeviation: dailyDeviation })));
                } }))));
};
DeviationFlags.displayName = 'DeviationFlags';
export default DeviationFlags;
//# sourceMappingURL=DeviationFlags.js.map